export const experience = [
  {
    id: 5,
    companyName: 'Magnético',
    jobTitle: {
      es: 'Desarrollador Mobile y Full-Stack',
      en: 'Mobile and Full-Stack Developer',
    },
    location: '',
    summary: {
      es: 'En Magnético desarrollo aplicaciones con React Native, Next.js, Nest.js y TypeScript, con un fuerte foco en desarrollo móvil. Mi proyecto principal es Escuela Fácil, una app de organización escolar en producción usada por varias escuelas en México. Participé en el desarrollo del módulo de transporte de punta a punta —modelo de datos, lógica de negocio, pantallas en React Native y páginas del backoffice— y desde hace varios meses soy el desarrollador principal: implemento features y mejoras, mantengo la aplicación en producción y participo del deployment.\nTambién desarrollé Soy Más, una app móvil que llevé desde cero hasta producción como único desarrollador mobile. Tomé decisiones de arquitectura, armé la UI y conecté la app con una API ya existente y con Supabase para autenticación.\nEn otro proyecto migré el almacenamiento de imágenes y videos de Cloudinary a S3 sobre un sistema de cinco APIs y un frontend, con un script que descargaba los archivos, los subía al bucket de S3 y actualizaba las URLs en las bases de datos.',
      en: 'At Magnético I build applications with React Native, Next.js, Nest.js, and TypeScript, with a strong focus on mobile development. My main project is Escuela Fácil, a school-management app in production used by several schools in Mexico. I helped build the transportation module end to end —data model, business logic, React Native screens, and backoffice pages— and for the past several months I have been the lead developer: I ship new features and improvements, maintain the production app, and take part in deployment.\nI also built Soy Más, a mobile app I took from scratch to production as the only mobile developer. I made architecture decisions, built the UI, and connected the app to an existing API and to Supabase for authentication.\nOn another project I migrated image and video storage from Cloudinary to S3 across a system of five APIs and a frontend, with a script that downloaded the files, uploaded them to the S3 bucket, and updated the URLs in the databases.',
    },
    startDate: '04/2025',
    endDate: '',
    image: '/images/companies/magnetico.png',
    imageSmall: '/images/companies/magnetico_sm.png',
    technologies: [
      'React Native',
      'TypeScript',
      'Expo',
      'Nest.js',
      'React',
      'Next.js',
      'PostgreSQL',
      'Node.js',
      'AWS',
    ],
  },
  {
    id: 4,
    companyName: 'Accenture',
    jobTitle: {
      es: 'Desarrollador Full-Stack',
      en: 'Full-Stack Developer',
    },
    location: '',
    summary: {
      es: 'Mantenimiento y evolución de dos aplicaciones internas utilizadas por todos los empleados de Accenture a nivel mundial. Desarrollé un módulo completo incluyendo UI, lógica de negocio, integración con APIs de terceros, tests y documentación. Corregí bugs y vulnerabilidades, mejoré código legacy y escribí tests unitarios. Trabajé en un entorno serverless con varios servicios de AWS (Lambda, API Gateway, DynamoDB, CloudFront, RDS, etc.) y di charlas técnicas internas sobre la arquitectura y la infraestructura de las aplicaciones.',
      en: 'Maintained and evolved two internal applications used by all Accenture employees worldwide. I built a complete module, including UI, business logic, third-party API integration, tests, and documentation. I fixed bugs and security issues, improved legacy code, and wrote unit tests. I worked in a serverless environment with several AWS services (Lambda, API Gateway, DynamoDB, CloudFront, RDS, and others) and gave internal technical talks on application architecture and infrastructure.',
    },
    startDate: '11/2023',
    endDate: '04/2025',
    image: '/images/companies/accenture.png',
    imageSmall: '/images/companies/accenture_sm.png',
    technologies: [
      'React',
      'Node.js',
      'AWS',
      'Vue.js',
      'C#',
      '.NET',
      'JavaScript',
      'PostgreSQL',
      'HTML',
      'CSS',
      'Sass',
      'Jest',
    ],
  },
  {
    id: 3,
    companyName: 'Zergex',
    jobTitle: {
      es: 'Desarrollador React Native y Full-Stack',
      en: 'React Native and Full-Stack Developer',
    },
    location: '',
    summary: {
      es: 'Desarrollé tres aplicaciones móviles con React Native y TypeScript desde cero hasta producción, con autenticación (Google, Apple y otras), pagos, mapas, geolocalización y notificaciones push. Hoy sigo manteniendo y mejorando Stetsiuk Weightlifting y RealMeet, ambas productivas y con usuarios activos, a tiempo parcial: implemento features y mejoras, doy soporte y participo del deployment.\nTambién desarrollé y llevé a producción en los stores a la aplicación Hub+, pero el proyecto se encuentra descontinuado.\nAsumí el rol de mentor para nuevos desarrolladores que se sumaron para dar mantenimiento a los proyectos y desarrollé paneles administrativos en React y TypeScript.\nEn el back-end trabajo con Node.js, Express, TypeScript, TypeORM y PostgreSQL: nuevas funcionalidades, optimizaciones, correcciones e integraciones con AWS S3. En uno de los proyectos desarrollé un script de automatización con Node.js para procesar miles de registros desde hojas de cálculo de Excel y guardarlos en PostgreSQL.',
      en: 'I built three mobile apps with React Native and TypeScript from scratch to production, including authentication (Google, Apple, and others), payments, maps, geolocation, and push notifications. I still maintain and improve Stetsiuk Weightlifting and RealMeet part-time, both in production with active users: I ship features and improvements, provide support, and take part in deployment.\nI also built and shipped Hub+ to the stores, but the project has been discontinued.\n I mentored new developers who joined to maintain the projects and built admin panels in React and TypeScript.\nOn the back-end I work with Node.js, Express, TypeScript, TypeORM, and PostgreSQL: new features, optimizations, fixes, and AWS S3 integrations. In one project I built a Node.js automation script to process thousands of records from Excel spreadsheets into PostgreSQL.',
    },
    startDate: '09/2023',
    endDate: '',
    image: '',
    imageSmall: '',
    technologies: [
      'React Native',
      'React',
      'TypeScript',
      'Node.js',
      'Express',
      'PostgreSQL',
    ],
  },
  {
    id: 2,
    companyName: 'Linné Studio',
    jobTitle: {
      es: 'Cofundador y desarrollador freelance',
      en: 'Freelance software developer',
    },
    location: '',
    summary: {
      es: 'Cofundador y desarrollador. Creación de sitios web y aplicaciones móviles para clientes en equipo con una diseñadora UX/UI. Me encargo de desarrollar tanto la funcionalidad como la UI de los proyectos en base a diseños creados en Figma.',
      en: 'Co-founder and developer. Creation of websites and mobile applications for clients as a team with a UX/UI designer. I develop both the functionality and the UI of the projects based on designs created in Figma.',
    },
    startDate: '02/2023',
    endDate: '11/2023',
    image: '/images/companies/linne.png',
    imageSmall: '/images/companies/linne_sm.png',
    technologies: ['Next.js', 'React', 'Astro', 'HTML', 'CSS', 'TypeScript'],
  },
  {
    id: 1,
    companyName: '',
    jobTitle: {
      es: 'Desarrollador freelance',
      en: 'Freelance software developer',
    },
    location: '',
    summary: {
      es: 'Me desempeño como desarrollador independiente creando sitios web para diversos clientes, casi siempre en equipo con otros desarrolladores y/o diseñadores UX/UI. Trabajo principalmente con React y Next.js. Mi objetivo es cumplir al máximo las expectativas del cliente, entregando software de calidad dentro de las fechas estipuladas.',
      en: 'I work as an independent developer creating websites for diverse clients, often as part of a team with other developers and UX/UI designers. I mainly work with React and Next.js. My goal is to meet client expectations, delivering quality software within the stipulated dates.',
    },
    startDate: '08/2022',
    endDate: '06/2023',
    image: '/images/companies/laptop-code.png',
    imageSmall: '/images/companies/laptop-code.png',
    technologies: [
      'Next.js',
      'React',
      'JavaScript',
      'HTML',
      'CSS',
      'TailwindCSS',
    ],
  },
];
